import Vue from "vue";
// import style from "./style.vue";
import Component from "vue-class-component";
import cloneDeep from "lodash/cloneDeep";
import type { ElForm } from "element-ui/types/form";
import type { ElUpload } from "element-ui/types/upload";
import { Prop, Watch, Inject, Provide } from "vue-property-decorator";
import Upload from "../upload/upload.vue";
import { numberToArray, noop, QinggerLibUtils } from "@/util";
import { IPSService } from "@/services/ipsServices";
import { RenovationColor, RenovationColorList } from "@/views/components/styleConfig";
import ShopDisplay from "@/views/components/shopDisplaySketchMap/display";
import ShopDisplayEdit from "@/views/components/shopDisplaySketchMap/displayEdit";
import imagePreview from "@/views/components/imgPreview";
const isset = QinggerLibUtils.isset;

const defaultBg = "https://ssl-picture.tenyun.runsasoft.com/54200870-8371-11ea-9b4f-ef6ec191275b";

enum ACTIVE {
	BACK,
	SWIPER,
	PRI,
	ICON,
	GUIDE,
}

const FileldList = ["HotAd", "HotBg", "HotStyle", "guide", "HoverIcon"];

const AdLinkType = ["", "期刊", "商品", "商品列表", "直播", "秒杀", "团购", "活动", "促销", "商品组", "促销", "微页面", "优惠卷", "小程序"];

const FileldList2 = ["HotAd", "HotBg", "HotStyle", "guide"];
@Component({
	// mixins: [style],
	components: {
		Upload,
		ShopDisplay,
		ShopDisplayEdit,
	},
})
export default class Hot extends Vue {
	$refs: {
		hotForm: ElForm;
		hoverIcon: ElForm;
		UploadImg: ElUpload;
		hot: ElForm;
	};

	@Prop({ default: RenovationColor.redOrangeWhite })
	themeCode: number;

	@Prop()
	sgId: number;

	@Prop({ default: false })
	disabled: boolean;

	@Prop({ default: 5 })
	fromPage;

	// 运营模式 1 镜单  2 镜千 3 云单 4 云千
	@Inject({ default: 0 })
	mode: number;

	setTitle = "";

	theme = "";

	defaultAd = {
		sgwpId: 3,
		fieldType: "HotAd", // hot广告页
		hotAdvert: 1,
		desc: {
			pName: "hot广告位",
			pWidth: 750,
			pHeight: 300,
			pMaxPage: 5,
		},
	};

	data: any = {
		sgId: 1,
		showBackPic: 1,
		showType: 1,
		qiKanShowType: 1,
		backPic: "",
		list: [this.defaultAd],
	};

	activeIndex = -1;

	displayData = [];

	ygswpId = 0;

	coupon = 0;

	connectedClass = [];

	@Provide()
	openCoupon() {
		return this.coupon;
	}

	@Watch("displayData", { deep: true, immediate: true })
	watchDisplayData(n, o) {
		if (n !== o) {
			this.activeIndex = n.findIndex((v) => v.isActived);
		}
	}

	maxPage: number[] = numberToArray(20);

	activeItem = 0;

	hotAdvert = 1;

	@Watch("themeCode", { deep: true, immediate: true })
	watchThemeCode(n, o) {
		this.theme = RenovationColorList[this.themeCode || 1] || [];
	}

	/**
	 * 获取关联分类
	 */
	public getAttributeList(): Promise<any> {
		return IPSService.getAttributeList().then((res) => {
			return isset(res, "list") ? res.list : [];
		});
	}

	sgHotSave() {
		const index = this.validateConfig();
		if (index !== -1) {
			this.displayData[index].isActived = true;
			setTimeout(() => {
				if ((this.$refs.hot.$refs[this.displayData[index].fieldType] as ElForm).$refs.form) {
					((this.$refs.hot.$refs[this.displayData[index].fieldType] as ElForm).$refs.form as ElForm).validate(noop);
				}
			}, 0);
			this.$nextTick(() => {
				this.$el.querySelector(".is-actived").scrollIntoView({ behavior: "smooth", block: "start" });
			});
			return false;
		}
		const bgInfo = this.displayData.find((v) => v.fieldType === "HotBg");
		let configList = cloneDeep(this.displayData.filter((v) => v.fieldType === "HotAd" || v.fieldType === "guide" || v.fieldType === "HoverIcon"));
		configList = configList.map((v) => {
			v.fieldType === "HotAd" && (v.fieldType = "Propagate");
			return v;
		});
		const postParams = {
			sgId: this.sgId,
			showType: 1,
			qiKanShowType: this.displayData.find((v) => v.fieldType === "HotStyle").desc.qiKanShowType,
			showBackPic: bgInfo.desc.showBackPic,
			backPic: bgInfo.desc.backPic,
			isUsePropagate: configList.find((v) => v.fieldType === "Propagate") ? configList.find((v) => v.fieldType === "Propagate").hotAdvert || 0 : 0,
			list: configList,
		};
		IPSService.decorationThemeHotSave({ postParams }).then((res) => {
			if (res && res.result) {
				this.$message.success("保存成功");
			}
		});
	}

	siteHotSave(isPre) {
		const index = this.validateConfig();
		if (index !== -1) {
			this.displayData[index].isActived = true;
			setTimeout(() => {
				if ((this.$refs.hot.$refs[this.displayData[index].fieldType] as ElForm).$refs.form) {
					((this.$refs.hot.$refs[this.displayData[index].fieldType] as ElForm).$refs.form as ElForm).validate(noop);
				}
			}, 0);
			this.$nextTick(() => {
				this.$el.querySelector(".is-actived").scrollIntoView({ behavior: "smooth", block: "start" });
			});
			return false;
		}
		let pList = this.displayData.filter((v) => v.fieldType === "HotAd" || v.fieldType === "guide");
		pList = pList.map((v) => {
			v.fieldType === "HotAd" && (v.fieldType = "Propagate");
			return v;
		});

		const showBackPic = this.displayData.find((v) => v.fieldType === "HotBg").desc.showBackPic;
		const qiKanShowType = this.displayData.find((v) => v.fieldType === "HotStyle").desc.qiKanShowType;
		const backPic = this.displayData.find((v) => v.fieldType === "HotBg").desc.backPic;
		const loading = this.$loading({
			lock: true,
			text: "请稍等...",
			spinner: "el-icon-loading",
			background: "rgba(225,225,225,0.3)",
		});
		const postParams = {
			siteId: +this.$route.params.siteId,
			showType: 1,
			showBackPic,
			qiKanShowType,
			backPic,
			list: pList,
		};
		this.displayData.splice(
			this.displayData.findIndex((v) => v.fieldType === "Propagate"),
			1,
			{
				fieldType: "HotAd",
				isActived: false,
				hotAdvert: 1,
				ygswpId: pList.find((v) => v.fieldType === "Propagate").ygswpId,
				desc: {
					list: pList.find((v) => v.fieldType === "Propagate").desc.list,
				},
			},
		);
		if (!isPre) {
			IPSService.siteHotSave({ postParams }).then(
				(response) => {
					if (response.result) {
						setTimeout(() => {
							if (loading) {
								this.displayData = this.displayData.filter((v) => FileldList2.includes(v.fieldType));
								loading.close();
								this.$message.success("保存成功");
							}
						}, 1000);
					} else {
						this.$message.success("保存失败");
					}
				},
				() => {
					if (loading) {
						loading.close();
					}
				},
			);
		} else {
			this.onPreview(postParams, loading);
		}
	}

	beforeSave(isPre) {
		this.mode === 2 ? this.siteHotSave(isPre) : this.sgHotSave();
	}

	validateConfig(): number {
		let index = -1;
		this.displayData = this.displayData.map((v) => {
			v.isActived = false;
			return v;
		});
		this.displayData.map((v, i) => {
			switch (v.fieldType) {
				case "HotBg":
					if (v.desc.showBackPic === 1 && !v.desc.backPic) {
						index = i;
					}
					break;
				case "HotAd":
					if (this.mode == 1 && (!v.desc.pName || !v.desc.pName.trim() || !v.desc.pHeight)) {
						index = i;
					}
					if (this.mode === 2) {
						let message = "";
						const isPic = v.desc.list.some((vl) => !vl.advPic);
						const isCouponImg = v.desc.list.some((val) => val.linkList.some((vls) => vls.linkType === 12 && !vls.couponInfo.couponCover));
						const isCouponPoint = v.desc.list.some((val) => val.linkList.some((vls) => vls.linkType === 12 && !vls.couponInfo.points));
						const isRecriptConfig = v.desc.list.some((val) => !!val.receiptConfig?.type && !val.receiptConfig?.id);

						(isPic || isCouponImg || isCouponPoint || isRecriptConfig) && (index = i);
						isCouponPoint && (message = "请填写优惠券价格");
						isCouponImg && (message = "请上传优惠券图片");
						isPic && (message = "请上传图片");
						isRecriptConfig && (message = "请设置顾客参与门槛！");
						if (isPic || isCouponImg || isCouponPoint || isRecriptConfig) {
							this.$message.warning(message);
						}
					}
					break;
				case "guide":
					if (!v.desc.guideContent || !v.desc.guideContent.trim()) {
						index = i;
					}
					break;
				case "HoverIcon":
					if (v.desc.list) {
						const flag = v.desc.list.every((hic) => {
							if (hic.page === 16) {
								return hic.title && hic.title.trim() && hic.pageId;
							} else {
								return hic.title && hic.title.trim();
							}
						});
						!flag && (index = i);
					} else {
						index = i;
					}
					break;
				case "HotBg":
					if (v.showBackPic === 1 && !v.backPic) {
						index = i;
					}
					break;
				default:
					break;
			}
		});
		return index;
	}

	getSgHotInfo() {
		IPSService.decorationThemeHotInfo({ postParams: { sgId: this.sgId } }).then((res) => {
			const resp = res;
			if (!resp.list.find((v) => v.fieldType === "Propagate")) {
				resp.list.unshift(this.defaultAd);
				this.hotAdvert = 2;
			}
			if (!resp.backPic) {
				resp.backPic = defaultBg;
			}
			const bg = {
				sort: 1,
				isActived: !this.disabled,
				fieldType: "HotBg",
				desc: {
					showBackPic: resp.showBackPic,
					backPic: resp.backPic,
				},
			};
			const hoverIcon = resp.list.find((v) => v.fieldType === "HoverIcon");
			const pIndex = resp.list.findIndex((v) => v.fieldType === "Propagate");
			if (pIndex != -1) {
				resp.list[pIndex].fieldType = "HotAd";
				resp.list[pIndex].hotAdvert = resp.isUsePropagate || 0;
			} else {
				resp.list.push(this.defaultAd);
			}
			this.displayData.push(bg);
			this.displayData = this.displayData.concat(
				resp.list.map((l) => {
					return Object.assign({}, l, { isActived: false });
				}),
			);
			this.displayData.push({
				fieldType: "HotStyle",
				isActived: false,
				desc: {
					qiKanShowType: resp.qiKanShowType,
				},
			});
			this.displayData = this.displayData.filter((v) => FileldList.includes(v.fieldType));
			if (hoverIcon) {
				const miniPage = hoverIcon.desc.list.filter((v) => v.page === 16);
				if (miniPage.length) {
					Promise.all(this.getMiniName(miniPage)).then((result) => {
						result.forEach((r) => {
							resp.list
								.find((f) => f.fieldType === "HoverIcon")
								.desc.list.forEach((v) => {
									if (r.pageId === v.pageId) {
										v.pageName = r.pageName;
									}
								});
						});
					});
				}
			}
		});
	}

	getShowData(response) {
		const resp = response;
		const bg = {
			sort: 1,
			isActived: !this.disabled,
			fieldType: "HotBg",
			desc: {
				showBackPic: resp.showBackPic,
				backPic: resp.backPic,
			},
		};
		this.displayData.push(bg);
		// 目前只会存在两个list，一个guide，一个Propagate
		const guider = resp.list.find((v) => v.fieldType === "guide");
		if (resp.list.length > 1) {
			this.displayData.push({
				fieldType: "guide",
				isActived: false,
				ygswpId: guider ? guider.ygswpId : null,
				desc: {
					guideContent: guider?.desc?.guideContent || [],
				},
			});
		}
		const hotAd = resp.list.find((v) => v.fieldType === "Propagate");
		this.displayData.push(
			{
				fieldType: "HotAd",
				isActived: false,
				hotAdvert: 1,
				ygswpId: hotAd ? hotAd.ygswpId : null,
				desc: {
					list: hotAd?.desc?.list || [],
				},
			},
			{
				fieldType: "HotStyle",
				isActived: false,
				desc: {
					qiKanShowType: resp.qiKanShowType,
				},
			},
		);
	}

	getSiteHotInfo() {
		IPSService.siteHotInfo({
			postParams: {
				siteId: +this.$route.params.siteId,
			},
		}).then(
			(response) => {
				this.getShowData(response);
			},
			// () => {
			//   if (loading) {
			//     loading.close();
			//   }
			// },
		);
	}

	async mounted() {
		this.mode === 2 && (this.coupon = await this.getCouponConfig());
		// 获取网点组的hot页配置详情
		this.mode === 2 ? this.getSiteHotInfo() : this.getSgHotInfo();

		this.mode === 2 && (this.connectedClass = await this.getAttributeList());
	}

	getCouponConfig() {
		return IPSService.siteGroupConfig({
			postParams: {
				sgId: this.sgId,
			},
		}).then((res) => {
			return res.isOpenExchangeCoupon || 0;
		});
	}

	getMiniName(arr = []): Promise<any>[] {
		arr = arr.filter((v) => !!v.pageId);
		return arr.map((v, i) => {
			return IPSService.miniPageInfo({
				postParams: {
					pageId: v.pageId,
				},
			});
		});
	}

	// 预览;
	onPreview(postParams, loading) {
		IPSService.siteHotConfigDisplay({ postParams }).then(
			(response) => {
				if (response.disPlayUrl) {
					if (loading) {
						loading.close();
					}
					imagePreview.open({ img: response.disPlayUrl }).catch(() => {});
				}
			},
			() => {
				if (loading) {
					loading.close();
				}
			},
		);
	}

	render(h) {
		return (
			<section class="nav-Menu hot" style={{ padding: this.disabled ? 0 : "" }}>
				<div class="nav-container" style={{ height: this.disabled ? "100%" : "calc(100% - 51px)", padding: this.disabled ? 0 : "" }}>
					<div class="left-phone bg-white relative-position" style={{ width: this.disabled ? "100%" : "25vw", "min-width": this.fromPage !== 5 ? "475px" : "" }}>
						<ShopDisplay fromPage={this.fromPage} themeCode={Number(this.themeCode)} defaultBg={this.theme[2] === "#fff" ? "#f6f5f6" : this.theme[2]} v-model={this.displayData} disabled={this.disabled} />
					</div>
					<ShopDisplayEdit
						v-model={this.displayData[this.activeIndex]}
						attrButeList={this.connectedClass.map((v) => {
							v.value_name = v.attrName;
							v.value_no = v.attrCode;
							v.class_code = v.attrCode;
							v.isLeafe = !v.list || !v.list.length;
							return v;
						})}
						themeCode={Number(this.themeCode)}
						ref="hot"
						fromPage={this.fromPage}
						disabled={this.disabled}
					/>
				</div>
				{!this.disabled && (
					<div class="bottom-save">
						<el-button type="primary" onClick={this.beforeSave.bind(this, 0)}>
							保存
						</el-button>
						&nbsp;&nbsp;
						{this.mode === 2 && (
							<span class="scopeSpan" onClick={this.beforeSave.bind(this, 1)}>
								预览
							</span>
						)}
					</div>
				)}
			</section>
		);
	}
}
